import { Injectable } from "@angular/core";
import { AppConfig, UvExplorerClient } from "common";
import { AuditLogPagination } from "configuration/components/audit-log-table/audit-log-table.component";
import { Observable } from "rxjs";
import { IAuditLogEntryListDto } from "UvExplorerServer.Dtos.TS/AuditLogging/AuditLogEntryListDto";

@Injectable()
export class AuditLogService {
    private baseUrl = this.appConfig.dataServiceUrl + `api/data/auditlog`;

    constructor(private appConfig: AppConfig, private uvExplorerClient: UvExplorerClient) {
        this.baseUrl = `${this.baseUrl}/list`;
    }
    public getAuditLog(pagination: AuditLogPagination, logType: string): Observable<IAuditLogEntryListDto> {
        let eventType = encodeURIComponent(pagination.EventType);
        let user = encodeURIComponent(pagination.User);
        let description = encodeURIComponent(pagination.Description);
        let deviceName = encodeURIComponent(pagination.DeviceName);
        let ipAddress = encodeURIComponent(pagination.IpAddress);
        let macAddress = encodeURIComponent(pagination.MacAddress);
        let ifIndex = encodeURIComponent(pagination.IfIndex);
        let ifName = encodeURIComponent(pagination.IfName);

        let url = `${this.baseUrl}?LogType=${logType}&SortBy=TimeStamp&Ascending=false&Skip=${pagination.Skip}&Limit=${pagination.Limit}`;
        if (eventType) {
            url += `&EventType=${eventType}`;
        }
        if (user) {
            url += `&User=${user}`;
        }
        if (description) {
            url += `&Description=${description}`;
        }
        if (deviceName) {
            url += `&DeviceName=${deviceName}`;
        }
        if (ipAddress) {
            url += `&IpAddress=${ipAddress}`;
        }
        if (macAddress) {
            url += `&MacAddress=${macAddress}`;
        }
        if (ifIndex) {
            url += `&IfIndex=${ifIndex}`;
        }
        if (ifName) {
            url += `&IfName=${ifName}`;
        }

        return this.uvExplorerClient.get(url);
    }
}